import styled from 'styled-components';
import { animated } from 'react-spring';
import { FADE, buttonRamp, t } from 'theme';

const ButtonCooldown = styled(animated.div)`
  position: absolute;
  opacity: 0.6;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
`;

const Tooltip = styled.div`
  padding: 2px 5px;
  border: 1px solid ${t('panelBorder')};
  box-shadow: -1px 3px 2px ${t('panelShadow')};
  background: ${t('panel')};
  color: ${t('fg')};
  transition: background-color ${FADE}, color ${FADE}, border-color ${FADE};
  top: 25px;
  left: 15px;
  z-index: 999;
  position: absolute;
  line-height: 1.5;
  font-size: 0.8rem;
  text-align: left;
  width: 100%;
`;

const Button = styled.button`
  min-width: 100px;
  max-width: 200px;
  position: relative;
  text-align: center;
  border: 1px solid ${props => (props.disabled ? t('rule')(props) : t('panelBorder')(props))};
  margin-bottom: 5px;
  padding: 5px 10px;
  cursor: pointer;
  user-select: none;
  transition: background-color ${FADE}, color ${FADE}, border-color ${FADE};
  // Level ramps the button from the palette's base to its opposite; the label flips to stay
  // readable against whichever end it lands on. See theme.buttonRamp.
  background-color: ${props => (props.disabled ? t('buttonDisabledBg')(props) : buttonRamp(props).background)};
  color: ${props => (props.disabled ? t('buttonDisabled')(props) : buttonRamp(props).text)};
  & ${Tooltip} {
    display: none;
  }
  &:hover {
    text-decoration: ${props => (props.disabled ? 'none' : 'underline')};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  }
  &:hover ${Tooltip} {
    display: ${props => (props.disabled ? 'block' : 'block')};
  }
`;

const TooltipEntry = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export { Button, ButtonCooldown, Tooltip, TooltipEntry };
